<template>
  <div class="tool">
    <!-- 工具 -->

    <ul>
      <li @click="blankLink('PDFturnTXT')">
        <div class="text">PDF转TXT</div>
        <i class="el-icon-refresh"></i>
      </li>
      <li @click="blankLink('FBAprint')">
        <div class="text">FBA标签打印</div>
        <i class="el-icon-printer"></i>
      </li>
      <li @click="$refs.wuliu.dialogVisible = true">
        <div class="text">物流查询</div>
        <img src="@/assets/icon/wuliu.png" alt="">
      </li>
    </ul>
    <!-- 物流 -->
    <wuliu ref="wuliu" />
  </div>
</template>
<script>
import wuliu from './wuliu.vue'
export default {
  components: {
    wuliu
  },
  data() {
    return {

    };
  },
  methods: {
    // 跳转页面
    blankLink(link) {
      let url = this.$router.resolve({
        path: '/' + link,
      });
      window.open(url.href, "_blank");
    },

  }
}
</script>
<style lang='scss' scoped>
.tool {
  position: fixed;
  top: 50%;
  right: 0;
  transform: transition(0, -50%);
  z-index: 9999;

  ul {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

    li {

      height: 40px;
      width: 40px;
      background-color: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 5px 0 0 5px;


      &:hover {
        background-color: #b4272d;
        color: #fff;
        border-radius: 0;

        .text {
          display: flex;
          background-color: #b4272d;
        }
      }

      i {
        font-size: 25px;
      }

      .text {

        position: absolute;
        top: 0;
        right: 40px;
        height: 40px;
        z-index: 999;
        background-color: #fff;
        width: 100px;
        display: none;
        justify-content: center;
        align-items: center;
        border-radius: 5px 0 0 5px;
      }

      img {
        width: 25px;
      }
    }
  }
}
</style>